/**
 * SubViewport parser registration.
 */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseSubViewport } from './parser';
const subViewportRegistration = {
    typeName: 'SubViewport',
    parser: parseSubViewport,
};
nodeRegistry.register(subViewportRegistration);
//# sourceMappingURL=index.js.map